import i18n from '@/i18n'
import type { Router, RouteMeta } from 'vue-router'

const $t = i18n.global.t

export const setupI18NGuard = (router: Router) => {
  router.afterEach((to, from) => {
    const appName = $t('appName')

    const { title = '', localeKey = '' } = (to.meta || {}) as RouteMeta

    if (localeKey) {
      document.title = $t(localeKey as string) + ' - ' + appName
    } else {
      document.title = title ? title + ' - ' + appName : appName
    }
  })
}
